import React from "react";

import { Breadcrumbs, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeIcon from "@mui/icons-material/Home";
const SecondHero = ({ page, title, mb, breadcrumb, img }) => {
  return (
    <div
      className={`grid place-content-center px-4 min-h-[70vh] md:min-h-[70vh] lg:min-h-[60vh] mb-${mb} secondHero relative z-10`}
      style={{
        backgroundImage: `url(${img})`,
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}>
      <div className="absolute w-full h-full bg-black/20 z-0 "></div>
      <div
        className="text-center text-white flex-c flex-col relative z-10"
        data-aos="fade-up"
        data-aos-delay={500}
        data-aos-once={true}>
        <Stack spacing={2}>
          <Breadcrumbs
            className="text-white text-3xl"
            separator={
              <NavigateNextIcon fontSize="small" sx={{ color: "white" }} />
            }
            aria-label="breadcrumb">
            {breadcrumbs(breadcrumb)}
          </Breadcrumbs>
        </Stack>
        <h2 className="text-5xl sm:text-6xl font-bold my-4">{title}</h2>
      </div>
    </div>
  );
};

export default SecondHero;
const breadcrumbs = (serviceType) => [
  <Link
    underline="hover"
    key="1"
    className="text-white hover:text-primary flex items-center"
    to="/">
    <HomeIcon />
    Home
  </Link>,
  <Typography className="text-white" key="2">
    Services
  </Typography>,
  <Typography
    className="text-white bg-secondary px-2 py-1 rounded-full"
    key="3">
    {serviceType}
  </Typography>,
];
